<template>
    <v-dialog :value="value" @input="$emit('input')" scrollable max-width="700px" persistent transition="dialog-transition">
        <v-container>
            <v-card>
                <v-card-title primary-title>
                    <h1>Termini e Condizioni</h1>
                </v-card-title>
                <v-divider class="mx-2"></v-divider>
                <v-card-text>
                    <h2>Prenotazioni e accettazione</h2>
                    <p>
                        <ol>
                            <li>Per chiedere la disponibilità di camere si utilizza il modulo di richiesta di disponibilità del nostro sito web.</li>
                            <li>Ricevuta la richiesta rispondiamo entro 24 ore con una mail di comunicazione di disponibilità di camere in cui indichiamo le condizioni di soggiorno, i prezzi e le modalità di pagamento. Rispondiamo a tutti, anche nel caso di mancata disponibilità .</li>
                            <li>Per effettuare una prenotazione è sufficiente rispondere con una email alla nostra comunicazione di disponibilità.</li>
                            <li>La camera si intende confermata esclusivamente con l’invio di una nostra email di conferma della prenotazione che contiene i dati della vostra permamenza nel B&B e il prezzo</li>
                            <li>Il giorno di arrivo il check in si effettua a partire dalle ore 14:00; il giorno della partenza il check out si effettua entro le ore 10:30.</li>
                            <li>All’arrivo ciascun ospite deve esibire, ai fini degli obblighi di legge, un valido documento di identità; in caso contrario non può essere accettato.</li>
                            <li>Ci riserviamo il diritto di sostituire la camera assegnata all’ospite con altra di livello pari o superiore senza preavviso e senza aumento di prezzo.</li>
                        </ol>
                    </p>

                    <h2>Prezzi e modalità di pagamento</h2>
                    <p>
                        <ol>
                            <li>I prezzi sono intesi per camera e per notte e comprendono la prima colazione. E’ esclusa l’imposta di soggiorno che comporta una spesa addizionale di 2 euro al giorno per persona,</li>
                            <li>Il prezzo del soggiorno è quello che comunichiamo nella mail di accettazione della prenotazione.</li>
                            <li>Con la conferma della prenotazione chiediamo, a titolo di garanzia, i dati della carta di credito. Tali dati non vengono utilizzati per effettuare un addebito relativo al costo del soggiorno ma esclusivamente per l’incasso dell’eventuale penale dovuta per cancellazione o riduzione del soggiorno.</li>
                            <li>Il prezzo del soggiorno sarà pagato, al momento della partenza, in contanti, carta di credito, bonifico bancario.</li>
                        </ol>
                    </p>

                    <h2>Cancellazioni</h2>
                    <p>
                        <ol>
                            <li>La cancellazione o riduzione di una prenotazione già confermata deve essere comunicata con email a: info@oblobb.it oppure via telefono al numero + 39 3490699160.</li>
                            <li>E’ possibile cancellare o ridurre la propria prenotazione, senza alcun addebito, fino a 15 giorni prima della data del suo arrivo al B&B.</li>
                            <li>Per cancellazioni o riduzioni del soggiorno comunicate al di sotto dei 15 giorni dalla data di arrivo addebitiamo una penalità di importo pari al costo di una notte.</li>
                            <li>Per cancellazioni comunicate al di sotto di sette giorni dalla data di arrivo o in caso di mancato arrivo addebitiamo una penalità di importo pari al costo dell’intero soggiorno.</li>
                            <li>Se l’ospite arriva ma non vuole rimanere nel B&B è tenuto a pagare l’intero importo del soggiorno</li>
                            <li>Se l’ospite arriva e chiede di ridurre il soggiorno è tenuto a pagare l’intero importo del soggiorno confermato.</li>
                        </ol>
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="$emit('close-terms')">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-container>
    </v-dialog>
</template>

<script>
export default {
    props: { value: { required: true } },

    data: () => {
        return {

        }
    }
}
</script>